import { render, staticRenderFns } from "./registrar.vue?vue&type=template&id=82a1ec9c"
import script from "./registrar.vue?vue&type=script&lang=js"
export * from "./registrar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports